<template>
  <section class="page-section page-section--welcome pt-5">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10">
          <h1 class="display-4 text-center pb-7"> Welkom <br> {{ store.name}} </h1>
        </div>

      </div>
    </div>
  </section>

  <ActionBtn status="test" @test="test"></ActionBtn>

  <section class="page-section page-section--welcome mt-5 bg-light-brown py-5 text-center fw-bold">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10">
          <div class="tex-center"></div>
          <p> De veiling gaat zo beginnen! <br><br> Let op de projectie in de zaal. </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ActionBtn from "../general/ActionBtn.vue";

import { visitor } from '../../stores/visitor';

export default {
  components: {
    ActionBtn,
  },
  setup() {
    const store = visitor()

    return {
      // you can return the whole store instance to use it in the template
      store,
    }
  },
  mounted() {
    //this.getActiveItem();
  },
  methods: {
    test(){
      let data = {
        "id": this.store.id,
        "name": this.store.name,
      }

      const test = Echo.private('auction-channel-' + this.store.auction)
        .whisper('phoneTest', data)
    }
  }
}
</script>
